import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { PATTERN_SEPARATOR, splitPattern } from '../../Utils/TextUtils';
import { initializeAllScales, updateScaleRanges } from './scaleUtils';
import { getFieldDefCore } from '../../../hooks/useFieldDef';

export const useScales = () => {
  // État unifié pour les scales et leurs dépendances
  const [scalesConfig, setScalesConfig] = useState({
    bandValues: null,
    arrayClassifBy: null,
    bandScales: [],
    colorScales: [],
    version: 0,
    isValid: false,
  });

  // Selectors
  const bandValuesIn = useSelector(
    (state) => state.CLASSIFIER_REDUCER.bandValues
  );
  console.log(bandValuesIn);
  const dicoNameRef = useSelector((state) => state.objects?.dicoNameRef ?? {});
  const arrayClassifBy = useSelector((state) => state.objects.arrayClassifBy);
  const objectsDefList = useSelector((state) => state.objects.objectsDefList);
  const timeline_shift = useSelector((state) => state.objects.timeline_shift);
  const timeLineCentralDates = useSelector(
    (state) => state.objects.timeLineCentralDate
  );
  const profiles = useSelector((state) => state.objects.profiles);
  const pattern = useSelector((state) => state.objects.pattern);
  const panels = useSelector((state) => state.objects.panels);

  const patterns = pattern.split(PATTERN_SEPARATOR);
  const fieldDefs = patterns.map((pattern, index) =>
    getFieldDefCore(objectsDefList, {
      objectType: pattern,
      fieldName: arrayClassifBy[index],
    })
  );
  // Initialisation des scales
  useEffect(() => {
    if (!pattern || !bandValuesIn || !arrayClassifBy) return;

    const { bandScales, colorScales, bandValues, ticks } = initializeAllScales(
      bandValuesIn,
      arrayClassifBy,
      objectsDefList,
      timeline_shift,
      profiles,
      splitPattern(pattern),
      timeLineCentralDates,
      fieldDefs,
      dicoNameRef
    );
    console.log('xyx');
    console.log(bandValues);
    setScalesConfig((prev) => ({
      bandValues,
      arrayClassifBy,
      bandScales,
      colorScales,
      version: prev.version + 1,
      ticks,
      isValid: bandScales.length > 0 && bandValues.length === bandScales.length,
    }));
  }, [
    bandValuesIn,
    arrayClassifBy,
    pattern,
    objectsDefList,
    timeline_shift,
    profiles,
    timeLineCentralDates,
  ]);

  // Mise à jour des ranges
  useEffect(() => {
    if (
      !pattern ||
      !scalesConfig.bandScales.length ||
      !scalesConfig.arrayClassifBy
    )
      return;

    const updatedBandScales = updateScaleRanges(
      scalesConfig.bandScales,
      splitPattern(pattern),
      scalesConfig.arrayClassifBy,
      objectsDefList
    );

    setScalesConfig((prev) => ({
      ...prev,
      bandScales: updatedBandScales,
      version: prev.version + 1,
    }));
  }, [panels, pattern, objectsDefList]);

  return { scalesConfig };
};
